<template>
  <div class="about-conts">
    <v-header />
    <div class="banner">
      <div class="bannerText">
        <span v-if="$i18n.locale === 'zh-CN'"
          >{{ $tc('lang.qaQcService.Minder') }}&nbsp;&nbsp;&nbsp;{{
            $tc('lang.qaQcService.pro_ser')
          }}&nbsp;&nbsp;&nbsp;{{ $tc('lang.qaQcService.pro_good') }}</span
        >
        <span v-if="$i18n.locale === 'en-US'">{{
          $tc('lang.qaQcService.service_title')
        }}</span>
        <br />
        <br />
        <br />
        <p>
          {{ $tc('lang.qaQcService.Quality_Control_ServicesOne') }}<br />
          {{ $tc('lang.qaQcService.Quality_Control_ServicesTow') }} <br />
          {{ $tc('lang.qaQcService.Quality_Control_ServicesThree') }} <br />
        </p>
      </div>
    </div>
    <div class="about-conts">
      <a-carousel autoplay class="carousel-page">
        <div class="carousel-items">
          <img class="page-imgsq" src="./image/service1.png" />
          <div class="carousel-span-one">
            <div class="span-text-one">
              <p>
                <span>{{
                  $tc('lang.qaQcService.Flexible_response_mechanism')
                }}</span
                ><br />
                {{ $tc('lang.qaQcService.Flexible_response_mechanism_text') }}
                {{
                  $tc('lang.qaQcService.Flexible_response_mechanism_text_one')
                }}
              </p>
              <p>
                <span>{{ $tc('lang.qaQcService.Save_time') }}</span
                ><br />
                {{ $tc('lang.qaQcService.order_text') }}<br />
                {{ $tc('lang.qaQcService.order_text_one') }}
              </p>
            </div>
            <p>
              {{ $tc('lang.qaQcService.mdservice') }}<br />{{
                $tc('lang.qaQcService.anxin')
              }}
            </p>
          </div>
        </div>
        <div class="carousel-items">
          <img class="page-imgsq" src="./image/service2.png" />
          <div class="carousel-span-tow">
            <p>
              {{ $tc('lang.qaQcService.mdservice') }}<br />{{
                $tc('lang.qaQcService.anxin')
              }}
            </p>
            <div class="span-text-tow">
              <p>
                <span>{{
                  $tc('lang.qaQcService.The_Best_Quality_Control_One')
                }}</span
                ><br />
                {{ $tc('lang.qaQcService.The_Best_Quality_Control_text_One') }}
              </p>
              <p>
                <span>{{
                  $tc('lang.qaQcService.The_Best_Quality_Control_Tow')
                }}</span
                ><br />
                {{ $tc('lang.qaQcService.The_Best_Quality_Control_text_Tow') }}
              </p>
            </div>
          </div>
        </div>
        <div class="carousel-items">
          <img class="page-imgsq" src="./image/service3.png" />
          <div class="carousel-span-tow">
            <p>
              {{ $tc('lang.qaQcService.mdservice') }}<br />{{
                $tc('lang.qaQcService.anxin')
              }}
            </p>
            <div class="span-text-tow">
              <p>
                <span>{{
                  $tc('lang.qaQcService.Intelligent_Order_System')
                }}</span
                ><br />
                {{ $tc('lang.qaQcService.Intelligent_Order_System_text') }}
              </p>
              <p>
                <span>{{
                  $tc('lang.qaQcService.Immediate_Processing_Management')
                }}</span
                ><br />
                {{
                  $tc('lang.qaQcService.Immediate_Processing_Management_text')
                }}
              </p>
            </div>
          </div>
        </div>
      </a-carousel>
    </div>
    <div class="awesomeSwiperStyle">
      <span>
        {{ $tc('lang.qaQcService.Product_Quality_Control_Services') }}</span
      >
      <div>
        <v-awesomeSwiper></v-awesomeSwiper>
      </div>
    </div>
    <div class="serviceTerritory">
      <div class="divSpLeft">
        <div>
          <img class="imgTerr" src="./image/triangle2.png" />
          <img class="imgTerr" src="./image/triangle.png" />
        </div>
      </div>
      <div class="divSpRight">
        <div class="divFrom">
          <div class="divItem">
            <span>01</span>
            <h4>{{ $tc('lang.qaQcService.Groceries') }}</h4>
            <p>
              {{ $tc('lang.qaQcService.Groceries_text') }}
            </p>
          </div>
          <div class="divItem">
            <span>02</span>
            <h4>{{ $tc('lang.qaQcService.Fabric_Textiles') }}</h4>
            <p>
              {{ $tc('lang.qaQcService.Fabric_Textiles_text') }}
            </p>
          </div>
          <div class="divItem">
            <span>03</span>
            <h4>{{ $tc('lang.qaQcService.Garment_Bags') }}</h4>
            <p>
              {{ $tc('lang.qaQcService.Garment_Bags_text') }}
            </p>
          </div>
          <div class="divItem">
            <span>04</span>
            <h4>
              {{ $tc('lang.qaQcService.Electronics_Electrical_Equipment') }}
            </h4>
            <p>
              {{ $tc('lang.qaQcService.Electronics_Electrical_text') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="evaluationService">
      <span>{{ $tc('lang.qaQcService.Best_Service_With_Amazing_Price') }}</span>
      <div class="divSpace">
        <div class="divLeft">
          <img src="./image/service_pro2.png" />
          <p class="pText">
            {{ $tc('lang.qaQcService.Product_Inspection_Service') }}
          </p>
          <p class="pTextOne">
            {{
              $tc('lang.qaQcService.start_from')
            }}&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
              $tc('lang.qaQcService.money')
            }}</span
            >&nbsp;&nbsp;&nbsp;&nbsp;{{ $tc('lang.qaQcService.start_from_s') }}
          </p>
          <a-button @click="onChangeLogin">{{
            $tc('lang.qaQcService.Get_specific_quote')
          }}</a-button>
        </div>
        <div class="divRight">
          <img src="./image/service_pro1.png" />
          <p class="pText">
            {{ $tc('lang.qaQcService.Loading_Supervision_Service') }}
          </p>
          <p class="pTextOne">
            {{
              $tc('lang.qaQcService.start_from')
            }}&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
              $tc('lang.qaQcService.money')
            }}</span
            >&nbsp;&nbsp;&nbsp;&nbsp;{{ $tc('lang.qaQcService.start_from_s') }}
          </p>
          <a-button @click="onChangeLogin">{{
            $tc('lang.qaQcService.Get_specific_quote')
          }}</a-button>
        </div>
      </div>
    </div>
    <v-footer />
  </div>
</template>
<script>
import Header from '../home/components/header.vue';
import Footer from '../home/components/footer.vue';
import awesomeSwiper from '../home/util/awesomeSwiper';
export default {
  name: 'qaQcService',
  data() {
    return {
      selected: '1',
    };
  },
  methods: {
    toggle(key) {
      this.selected = key;
    },
    onChangeLogin() {
      this.$router.push('/login');
    },
  },
  components: {
    'v-header': Header,
    'v-footer': Footer,
    'v-awesomeSwiper': awesomeSwiper,
  },
};
</script>
<style lang="less">
.banner {
  width: 100%;
  height: 65vh;
  background-image: url('./image/banner.png');
  .bannerText {
    padding-top: 10%;
    > span {
      font-size: 35px;
      color: #ffffff;
      font-weight: 300;
    }
    > p {
      font-size: 20px;
      color: #ffffff;
    }
  }
}
.about-conts {
  .carousel-page {
    // ==========轮播======
    .carousel-items {
      position: relative;
      /*背景图片*/
      .page-imgsq {
        width: 100%;
      }
      // 字体一
      .carousel-span-one {
        position: absolute;
        top: 0;
        > p {
          color: #ffffff;
          font-size: 50px;
          font-weight: 900;
          text-align: left;
          margin-left: 40px;
        }
        .span-text-one {
          > p > span {
            font-size: 30px;
            font-weight: 500;
          }
          color: #ffffff;
          font-size: 20px;
          text-align: left;
          margin-left: 40px;
          margin-top: 50px;
        }
      }
      // 字体二
      .carousel-span-tow {
        position: absolute;
        top: 80px;
        width: 100%;
        > p {
          color: #ffffff;
          font-size: 50px;
          font-weight: 900;
          margin-right: 70%;
        }
        .span-text-tow {
          margin-left: 50%;
          margin-top: 90px;
          > p > span {
            font-size: 30px;
            font-weight: 500;
          }
          color: #ffffff;
          font-size: 18px;
          text-align: left;
        }
      }
    }
  }
  .awesomeSwiperStyle {
    margin-top: 50px;
    > span {
      font-size: 30px;
      font-weight: 400;
    }
  }
  .serviceTerritory {
    width: 100%;
    height: 600px;
    margin-top: 210px;
    background-color: #b4b4b43b;
    > div {
      display: inline-block;
      height: 100%;
      vertical-align: top;
    }
    .imgTerr {
      width: 100px;
      top: 50px;
      margin-top: 50px;
      margin-left: 20px;
    }
    .divSpLeft {
      width: 40%;
      > div {
        margin-right: 40%;
      }
    }
    .divSpRight {
      width: 60%;
      position: relative;
      background-image: url('./image/rightBack.png');
      .divFrom {
        position: absolute;
        left: -30%;
        width: 100%;
        .divItem {
          overflow: hidden;
          display: inline-block;
          border: 1px solid #ffffff;
          box-shadow: 0 2px 12px 0 #e1e2e2;
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 10px;
          margin: 20px;
          width: 30%;
          height: 240px;
          position: relative;
          > span {
            position: absolute;
            bottom: -60px;
            left: 0;
            font-size: 90px;
            color: #b4b4b4;
            font-weight: 100;
          }
          > h4 {
            margin-top: 60px;
            font-size: 18px;
            color: #2a82e4;
          }
          > p {
            margin: 20px 40px;
          }
        }
      }
    }
  }
  .evaluationService {
    width: 100%;
    height: 600px;
    margin-top: 50px;
    > span {
      font-size: 30px;
      font-weight: 400;
    }
    .divSpace {
      display: flex;
      justify-content: space-around;
      .divLeft {
        height: 430px;
        width: 20%;
        border: 1px solid #ffffff;
        box-shadow: 0 2px 12px 0 #e1e2e2;
        border-radius: 10px;
        > img {
          width: 100px;
          margin-top: 70px;
        }
        .pText {
          margin-top: 20px;
          font-size: 30px;
        }
        .pTextOne {
          margin-top: 20px;
          font-size: 25px;
          > span {
            font-size: 30px;
            font-weight: 600;
          }
        }
        > button {
          background-color: #ff0000;
          color: #ffffff;
        }
      }
      .divRight {
        width: 20%;
        border: 1px solid #ffffff;
        box-shadow: 0 2px 12px 0 #e1e2e2;
        border-radius: 10px;
        > img {
          width: 100px;
          margin-top: 80px;
        }
        .pText {
          margin-top: 35px;
          font-size: 30px;
        }
        .pTextOne {
          margin-top: 35px;
          font-size: 25px;
          > span {
            font-size: 30px;
            font-weight: 600;
          }
        }
        > button {
          background-color: #ff0000;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
